import brandsQuery from '~layers/app/graphql/brands.gql'

export function useBrands() {
  const brandUrlMap = useState<Record<string, string>>('brandUrlMap', () => ({}))
  const error = ref<string>('')
  const brands = ref<any[]>([])
  const loading = ref<boolean>(false)

  const getBrandUrl = (value?: string | null) => {
    if (!value) {
      return null
    }

    if (!brandUrlMap.value || !Object.keys(brandUrlMap.value).length) {
      return null
    }

    return brandUrlMap.value[stringToSlug(value)] || null
  }

  const fetchBrands = async () => {
    loading.value = true

    const result = await useAsyncQuery<{
      brands: { brandsList: any[] }
    }>({
      query: brandsQuery,
    })
    error.value = result.error.value

    brands.value = result.data.value || []
    loading.value = false
  }

  return {
    error,
    fetchBrands,
    loading,
    brands,
    getBrandUrl,
  }
}
